import * as React from 'react';

import { type UniqueIdentifier } from '@dnd-kit/core';

import { useDriversQuery } from '../../hooks/queries/useDriversQuery';

import {
  HaulerSectionDivider,
  PinnedKanbanColumn,
  type TKanbanColumn,
} from './KanbanColumn';
import { type KanbanTask } from './KanbanTask';

interface HaulerDriversSectionProps {
  haulerId: string;
  haulerName: string;
  tasks: KanbanTask[];
  onTaskClick?: (taskId: UniqueIdentifier) => void;
  onRouteClick?: (routeId: string) => void;
  onSubmitForDriver?: (driverId: string) => void;
}

export const HaulerDriversSection = ({
  haulerId,
  haulerName,
  tasks,
  onTaskClick,
  onRouteClick,
  onSubmitForDriver,
}: HaulerDriversSectionProps) => {
  const { data: driversData } = useDriversQuery({
    haulerId,
    limit: 100,
  });

  const columns: TKanbanColumn[] = React.useMemo(() => {
    const drivers = driversData?.drivers ?? [];
    return [
      {
        id: `hauler-unassigned-${haulerId}`,
        title: 'Unassigned',
      },
      ...drivers.map((driver) => ({
        id: driver.id,
        title: `${driver.firstName} ${driver.lastName}`,
      })),
    ];
  }, [haulerId, driversData]);

  return (
    <>
      <HaulerSectionDivider label={haulerName} />
      {columns.map((col) => (
        <PinnedKanbanColumn
          key={col.id}
          column={col}
          tasks={tasks.filter((task) => task.columnId === col.id)}
          onTaskClick={onTaskClick}
          onRouteClick={onRouteClick}
          onSubmitForDriver={onSubmitForDriver}
        />
      ))}
    </>
  );
};
